import { Pencil, Trash2, Megaphone, Lock } from 'lucide-react';
import type { Observacao } from '../../api/hooks/useObservacoes';
import {
  CATEGORIA_CONFIG,
  NIVEL_CONFIG,
  btnSecondary,
} from './observacoes-professor-shared';
import {
  descricaoExibicao,
  formatDataCurta,
  isAvisoPedagogico,
  professorPodeEditarObservacao,
  OBSERVACAO_EDICAO_DIAS_PROFESSOR,
} from './observacoes-utils';

interface Props {
  obs: Observacao;
  onEdit: (obs: Observacao) => void;
  onRemove: (id: string) => void;
}

export function ObservacaoDetalhePanel({ obs, onEdit, onRemove }: Props) {
  const catInfo = CATEGORIA_CONFIG[obs.categoria];
  const nivelInfo = NIVEL_CONFIG[obs.nivelAtencao];
  const aviso = isAvisoPedagogico(obs);
  const podeEditar = !aviso && professorPodeEditarObservacao(obs);

  return (
    <div className="obs-desk-detail-inner">
      <div className="obs-desk-detail-head">
        <div className="obs-desk-detail-badges">
          <span
            className="obs-desk-detail-badge"
            style={{ background: catInfo.bg, color: catInfo.color }}
          >
            {aviso ? <Megaphone size={12} /> : catInfo.icon}
            {aviso ? 'Aviso resp.' : catInfo.label}
          </span>
          <span
            className="obs-desk-detail-badge"
            style={{ background: nivelInfo.bg, color: nivelInfo.color }}
          >
            {nivelInfo.label}
          </span>
          {obs.privado && (
            <span className="obs-desk-detail-badge obs-desk-detail-badge--priv">
              <Lock size={10} />
              Privada
            </span>
          )}
        </div>
        <h2 className="obs-desk-detail-title">{obs.titulo}</h2>
        <p className="obs-desk-detail-meta">
          {obs.aluno?.nome || '—'} · {formatDataCurta(obs.criadoEm)}
          {obs.dataReferencia && obs.dataReferencia !== obs.criadoEm.split('T')[0]
            ? ` · ref. ${formatDataCurta(obs.dataReferencia)}`
            : ''}
        </p>
      </div>

      <section className="obs-desk-detail-body">
        <h3 className="obs-desk-detail-section-title">Descricao</h3>
        <p className="obs-desk-detail-desc">{descricaoExibicao(obs.descricao || '')}</p>
      </section>

      {aviso ? (
        <p className="obs-desk-detail-aviso-msg">
          Registro gerado pelo fluxo de aviso ao responsavel. Somente leitura.
        </p>
      ) : podeEditar ? (
        <div className="obs-desk-detail-actions">
          <button type="button" onClick={() => onEdit(obs)} style={btnSecondary}>
            <Pencil size={14} />
            Editar
          </button>
          <button
            type="button"
            onClick={() => onRemove(obs.id)}
            style={{ ...btnSecondary, color: '#dc2626', borderColor: '#fecaca' }}
          >
            <Trash2 size={14} />
            Remover
          </button>
        </div>
      ) : (
        <p className="obs-desk-detail-readonly">
          Registro antigo ({'>'} {OBSERVACAO_EDICAO_DIAS_PROFESSOR} dias). Somente leitura — coordenacao
          pode alterar.
        </p>
      )}
    </div>
  );
}
